import * as React from "react";
const SvgFiRrCarCrash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-car-crash_svg__a)">
      <path
        fill="#062147"
        d="m24.013 15.331-.523-4.23a4.47 4.47 0 0 0-2.834-4.082L16.7 5.38a4.93 4.93 0 0 0-5.073.874L7.952 8.98a9.1 9.1 0 0 0-2.295 3.283s-.428.77-.445.811a3.44 3.44 0 0 0 .087 2.58c.169.398.416.759.726 1.06l-.033.082a2.5 2.5 0 0 0 4.6 1.964l4.8 1.925a2.5 2.5 0 0 0 4.686 1.738l.014-.035A3.01 3.01 0 0 0 23 20.5l.412-1.04a9.04 9.04 0 0 0 .6-4.129M12.89 7.801a2.98 2.98 0 0 1 3.066-.569l3.955 1.64A2.54 2.54 0 0 1 21.5 11.29c0 .012.419 3.388.419 3.388L10.028 9.924zM8.13 18.182h-.01l.02.008zm9.43 3.781h-.01l.018.006zm3.582-2.2a1 1 0 0 1-1.288.564L7.634 15.42a1 1 0 0 1-.5-.56 1.5 1.5 0 0 1-.08-1s.42-.758.437-.8a7.2 7.2 0 0 1 .916-1.636l1.62.648-.325.8a1 1 0 1 0 1.854.752l.328-.81 6.648 2.657-.33.813a1 1 0 1 0 1.854.752l.333-.822 1.622.648a7 7 0 0 1-.455 1.851zM4 11a1 1 0 0 1-1 1H1a1 1 0 0 1-.768-1.64l1.59-1.909a.7.7 0 0 0 0-.9l-1.59-1.91A1 1 0 0 1 1 4h2.3a.705.705 0 0 0 .7-.7V1A1 1 0 0 1 5.64.231l1.909 1.591a.7.7 0 0 0 .9 0l1.91-1.59A1 1 0 0 1 12 1v2a1 1 0 0 1-1.991.128l-.277.231a2.7 2.7 0 0 1-3.462 0l-.27-.224V3.3A2.707 2.707 0 0 1 3.3 6h-.164l.224.27a2.7 2.7 0 0 1 0 3.461l-.231.277A1 1 0 0 1 4 11"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-car-crash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCarCrash;
